import { type FC } from 'react'

import {
  type PimProductV11,
  PrescriptionV3PrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { priceGetFormattedPercentageDiscount } from '../../../../price'
import { useProductPageContext } from '../../productPageContext'
import { type ProductPrices, useProductPrices } from '../hooks/useProductPrices'

type ProductPageVariantBonusProps = {
  product: PimProductV11
}

export const ProductPageVariantBonus: FC<ProductPageVariantBonusProps> = ({
  product,
}) => {
  const { currentPrescriptionType, offerId } = useProductPageContext()
  const { discount, isDiscountValid, shouldUseReferencePrice }: ProductPrices =
    useProductPrices({
      currentPrescriptionType,
      offerId,
      product,
    })

  if (
    discount &&
    isDiscountValid &&
    currentPrescriptionType ===
      PrescriptionV3PrescriptionTypeEnum.NoPrescription
  ) {
    return (
      <div className="inline-flex min-w-12 items-center justify-center rounded-m bg-light-tertiary px-2 py-1 text-xs font-medium text-dark-primary-max">
        {priceGetFormattedPercentageDiscount(discount)}
        {shouldUseReferencePrice ? '*' : null}
      </div>
    )
  }

  return <div className="min-w-12" />
}
